import {ModuleTopic} from '@cp/model';

export default function calculateAverageScore(topics: ModuleTopic[], relatedScores: Record<string, number>): number {
  if (topics.length === 0) return 0;
  const scores = topics.map((topic) => relatedScores[topic.topic] || 0);
  const sum = scores.reduce((acc, score) => acc + score, 0);
  return sum / topics.length;
}
